import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useUsersStore } from '@stores/users'

import { MAX_PER_PAGE, getFirstQueryValue, normalizeArrayQuery, toPaginationValue } from '@helpers/route'

import { defineNuxtRouteMiddleware } from '#app'

/**
 * `/users` — query → store filters, mirroring `middleware/assessments.ts`. `page` / `per_page` are
 * also validated off the query by `useUsersApi` (query wins for those two); mirrored here so a deep
 * link leaves the store agreeing with what was requested.
 */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = useUsersStore()

  store.setFilterSearch(getFirstQueryValue(to.query?.q) || null)
  store.setFilterStatus(getFirstQueryValue(to.query?.status) || null)
  store.setFilterRoles(normalizeArrayQuery(to.query?.roles) ?? [])
  store.setFilterTeams(normalizeArrayQuery(to.query?.teams) ?? [])

  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
})
